var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_425)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3521 4.01072C8.55841 4.19427 8.57687 4.51031 8.39332 4.71663L5.65383 7.79593C5.3936 8.08844 4.94405 8.11065 4.65626 7.84521L3.64148 6.90925C3.43849 6.72203 3.42571 6.40571 3.61293 6.20272C3.80015 5.99974 4.11647 5.98696 4.31946 6.17417L5.10972 6.90305L7.6462 4.05195C7.82974 3.84563 8.14579 3.82718 8.3521 4.01072Z",
    fill: "#49AB9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11ZM6 12C9.3137 12 12 9.3137 12 6C12 2.68629 9.3137 0 6 0C2.68629 0 0 2.68629 0 6C0 9.3137 2.68629 12 6 12Z",
    fill: "#49AB9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedCard);
export default __webpack_public_path__ + "static/media/completed_card.0895b8719bb32800da9b86cfb1a9c647.svg";
export { ForwardRef as ReactComponent };